import { useRef } from 'react'
import { AuthorStat } from '../../types'
import { AuthorsGridBar } from './AuthorsGridBar'
import { useInView } from 'framer-motion'

interface Props extends AuthorStat {
  highlight: boolean
  max: number
}

export const AuthorsGridBarMotion = ({ ...props }: Props) => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, amount: 1 })

  return <AuthorsGridBar ref={ref} show={inView} {...props} />
}
